import { useGetIdentity, useTranslate } from "ra-core";
import { CreateSheet } from "../misc/CreateSheet";
import { CompanyInputs } from "./CompanyInputs";

interface CompanyCreateSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const CompanyCreateSheet = ({ open, onOpenChange }: CompanyCreateSheetProps) => {
  const { identity } = useGetIdentity();
  const translate = useTranslate();
  return (
    <CreateSheet
      resource="companies"
      title={translate("resources.companies.action.new", { _: "Новая компания" })}
      defaultValues={{ sales_id: identity?.id }}
      transform={(values: Record<string, unknown>) => {
        if (values.website && typeof values.website === "string" && !values.website.startsWith("http")) {
          values.website = `https://${values.website}`;
        }
        return values;
      }}
      open={open}
      onOpenChange={onOpenChange}
    >
      <CompanyInputs />
    </CreateSheet>
  );
};
